export const filterByCategories = selected => categories => selected.length
    ? categories.filter(category => selected.includes(category.cid))
    : categories;

export const filterByEmptyGames = categories => categories.filter(({ gameCodes }) => gameCodes.length);
